import ProjectService from "@/core/services/project.service";
import {
  AttachmentCategory,
  CreateProject,
  ProjectData,
  ProjectDataSelectedProperties,
  UpdateProject,
} from "@/core/models/project";
import { Commit } from "vuex";
import TradeEstimateService from "@/core/services/trade-estimate.service";
import ProjectEstimationService from "@/core/services/project-estimation.service";
import tradeEstimateService from "@/core/services/trade-estimate.service";
import historicalProjectService from "@/core/services/historical-project.service";
import projectService from "@/core/services/project.service";
import {
  DisputeRequestStatusEnums,
  ProjectJobStatusEnum,
} from "@/core/enums/ProjectsEnum";
import raiseIssueService from "@/core/services/raise-issue.service";
import { stringify } from "querystring";

export default {
  async attachmentCategory(
    { state, commit }: any,
    payload: AttachmentCategory
  ) {
    const { label, value } = payload;
    return ProjectService.attachmentCategory(label, value).then((response) => {
      return response;
    });
  },
  async createProject({ state, commit }: any, payload: CreateProject) {
    return ProjectService.createProject(payload).then((response) => {
      return response;
    });
  },
  async createRaiseProject({ state, commit }: any, payload: CreateProject) {
    return ProjectService.createRaiseProject(payload).then((response) => {
      return response;
    });
  },
  projectDetails({ commit }: { commit: Commit }, payload: any) {
    commit("setProjectDetails", payload);
  },
  resetProjectDetails(
    { commit, getters }: { commit: Commit; getters: any },
    payload: any
  ) {
    commit("resetProjectDetails", getters.defaultProjectDetails);
    commit("setProjectDispute", null);
  },
  setProjectAttachments({ commit }: { commit: Commit }, payload: any) {
    commit("setProjectAttachments", payload);
  },
  setProjectSpecialisms({ commit }: { commit: Commit }, payload: any) {
    commit("setProjectSpecialisms", payload);
  },
  removeProjectSpecialism({ commit }: { commit: Commit }, payload: any) {
    commit("removeProjectSpecialism", payload);
  },
  addProjectSpecialism({ commit }: { commit: Commit }, payload: any) {
    commit("addProjectSpecialism", payload);
  },
  setInvitedContractors({ commit }: { commit: Commit }, payload: any) {
    commit("setInvitedContractors", payload);
  },
  async getProjectData({ commit }: { commit: Commit }, payload: ProjectData) {
    const { projectRefId } = payload;
    return ProjectService.getProjectData(projectRefId).then((response) => {
      return response;
    });
  },
  async getProjectDataProperties(
    { commit }: { commit: Commit },
    payload: ProjectData
  ) {
    const { projectRefId } = payload;
    return ProjectService.getProjectDataProperties(projectRefId).then(
      (response) => {
        return response;
      }
    );
  },
  async getProjectDataSelectedProperties(
    { commit }: { commit: Commit },
    payload: ProjectDataSelectedProperties
  ) {
    const { projectRefId, propertyIds } = payload;
    return ProjectService.getProjectDataSelectedProperties(
      projectRefId,
      propertyIds
    ).then((response) => {
      return response;
    });
  },
  async updateProject(
    { state, commit }: any,
    payload: { data: UpdateProject; projectId: number }
  ) {
    return ProjectService.updateProject(payload.data, payload.projectId).then(
      (response) => {
        return response;
      }
    );
  },
  async updateSubSpecialismCategory(
    { state, commit }: any,
    payload: { data: UpdateProject; projectId: number }
  ) {
    return ProjectService.updateSubSpecialismCategory(
      payload.data,
      payload.projectId
    ).then((response) => {
      return response;
    });
  },
  async updateSpecialism(
    { state, commit }: any,
    payload: { specialism: any; projectId: number }
  ) {
    return ProjectService.updateSpecialism(
      payload.specialism,
      payload.projectId
    ).then((response) => {
      return response;
    });
  },
  async getFilterProjectData({ commit }: { commit: Commit }, params: any) {
    if (!params) return;
    return ProjectService.getFilterProjectData(params).then((response) => {
      return response;
    });
  },
  async setProjectRedirectTabName(
    { commit }: { commit: Commit },
    TabName: string | null
  ) {
    commit("setProjectRedirectTabName", TabName);
  },
  async getProjectCategoryList(
    { commit }: { commit: Commit },
    projectId: number
  ) {
    return ProjectService.getProjectCategoryList(projectId);
  },

  async getProjectEstimate({ commit }: { commit: Commit }, projectId: number) {
    return ProjectEstimationService.getProjectEstimateByProjectId(
      projectId,
      true
    );
  },
  async getProjectEstimateWithEscrow(
    { commit }: { commit: Commit },
    projectEstimateId: number
  ) {
    try {
      if (!projectEstimateId) return null;
      const response =
        await tradeEstimateService.getProjectEstimateWithEscrowStatus(
          projectEstimateId
        );

      commit("setProjectEstimateDataWithEscrowStatus", response);
      return response;
    } catch (error) {
      return null;
    }
  },

  setHistoricalProjectForm({ commit }: { commit: Commit }, value: any) {
    commit("setHistoricalProjectForm", value);
  },

  setHistoricalProjectFormSpecialism(
    { commit }: { commit: Commit },
    value: any
  ) {
    commit("setHistoricalProjectFormSpecialism", value);
  },

  async setProjectEstimateEscrowBalance(
    { commit }: { commit: Commit },
    projectId: any
  ) {
    try {
      const response = (await tradeEstimateService.getEscrowAccountBalance(
        projectId
      )) as any;
      if (response) commit("setProjectEstimateEscrowBalance", response.amount);
    } catch (error) {
      console.log(error);
    }
  },

  async updateRaiseProjectStatus(
    { state, commit }: any,
    payload: {
      projectId: number;
      data: {
        status: number;
      };
    }
  ) {
    return ProjectService.updateRaiseProjectStatus(
      payload.projectId,
      payload.data
    ).then((response) => {
      return response;
    });
  },

  async updateHistoricalProject(
    { state, commit }: any,
    payload: { data: UpdateProject; projectId: number }
  ) {
    return historicalProjectService
      .updateHistoricalJobDetail(payload.data, payload.projectId)
      .then((response) => {
        return response;
      });
  },
  async updateHistoricalProjectStatus(
    { state, commit }: any,
    payload: {
      projectId: number;
      data: {
        historicalProjectStatus: number;
        projectEstimateId: number;
      };
    }
  ) {
    return historicalProjectService
      .updateHistoricalJobStatus(payload.projectId, payload.data)
      .then((response) => {
        return response;
      });
  },
  async getRecommendationForJobDescription(
    { commit }: { commit: Commit },
    payload: any
  ) {
    try {
      const { prompt } = payload;
      return ProjectService.getRecommendationForJobDescription(prompt).then(
        (response) => {
          return response;
        }
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getRecommendationForJobTitle(
    { commit }: { commit: Commit },
    payload: any
  ) {
    try {
      const { prompt } = payload;
      return ProjectService.getRecommendationForJobTitle(prompt).then(
        (response) => {
          return response;
        }
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getSpecialismRecommendation(
    { commit }: { commit: Commit },
    payload: any
  ) {
    try {
      const { description } = payload;
      return ProjectService.getSpecialismRecommendation(description).then(
        (response) => {
          return response;
        }
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getNewAddedSubCategoryForProject(
    { commit }: { commit: Commit },
    payload: any
  ) {
    try {
      return ProjectService.getNewAddedSubCategoryForProject(payload).then(
        (response) => {
          return response;
        }
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getVideoConsultationRoomUrl(
    { commit }: { commit: Commit },
    payload: any
  ) {
    console.log("payload", payload);
    try {
      const { roomTitle, type } = payload;
      return ProjectService.getVideoConsultationRoomUrl({
        ...payload,
      }).then((response) => {
        return response;
      });
    } catch (error: any) {
      console.log(error);
      return error?.response;
    }
  },

  async fetchAllRequestedProjects(
    { commit }: { commit: Commit },
    payload: any
  ) {
    return ProjectService.getAllRequestedProjects(payload)
      .then((response) => {
        commit("setProjectRequestedList", response?.data);
        return response;
      })
      .catch((error) => {
        console.log("error", error);
      });
  },

  resetAllRequestedProjects({ commit }: { commit: Commit }, payload: any) {
    commit("setProjectRequestedList", payload);
  },
  async setProjectStatusCounts({ commit }: { commit: Commit }, payload: any) {
    try {
      const projectListing: any = await projectService.getAllProjects();
      const statusCounts = projectListing.data.reduce(
        (obj: any, project: any) => {
          const statusId = project.projectJobStatusId;
          obj[statusId] = (obj[statusId] || 0) + 1;
          return obj;
        },
        {}
      );
      statusCounts["all"] = projectListing?.totalCount || 0;
      const draftProjectData: any = await projectService.getAllProjects({
        projectJobStatus: ProjectJobStatusEnum.DRAFT_PROJECT,
      });
      statusCounts[ProjectJobStatusEnum.DRAFT_PROJECT] =
        draftProjectData?.totalCount || 0;

      const allRaiseIssue: any = await raiseIssueService.getAllIssue("", "");
      statusCounts["issue"] = allRaiseIssue?.length || 0;
      commit("setProjectStatusCountsList", statusCounts);
    } catch (error) {
      console.log("set project overview data");
    }
  },

  async getRateCategories({ commit }: { commit: Commit }, payload: any) {
    try {
      const data = await ProjectService.getRateCategories();
      commit("setRateCategories", data);
    } catch (error) {
      console.log(error);
    }
  },
  checkRateCategoryExist(
    { state, commit }: { state: any; commit: Commit },
    payload: any
  ) {
    const { categoryId } = payload;

    const hasMatch = state.rateCategories.some(
      (data: any) => data.categoryId === categoryId
    );

    return hasMatch;
  },
  async fetchAllProjects({ commit }: { commit: Commit }, payload: any) {
    const response: any = await projectService.getAllProjects(payload);
    if (response.page == 1) {
      commit("setAllProjects", response?.data);
      commit("setTotalPages", response?.totalPages);
      commit("setTotalProjects", response?.totalCount);
    } else {
      commit("appendAllProjects", response?.data);
    }
  },

  async fetchDraftProjects({ commit }: { commit: Commit }, payload: any) {
    const response: any = await projectService.getAllProjects(payload);
    if (response.page == 1) {
      commit("setDraftProjects", response?.data);
      commit("setTotalDraftProjectPages", response?.totalPages);
      commit("setTotalDraftProjects", response?.totalCount);
    } else {
      commit("appendDraftProjects", response?.data);
    }
  },

  async fetchCompletedProjects({ commit }: { commit: Commit }, payload: any) {
    const response: any = await projectService.getAllProjects(payload);
    if (response?.page == 1) {
      commit("setCompletedProjects", response?.data);
      commit("setTotalCompletedProjectPages", response?.totalPages);
      commit("setTotalCompletedProjects", response?.totalCount);
    } else {
      commit("appendCompletedProjects", response.data);
    }
  },

  async disputeProject(
    { commit }: { commit: Commit },
    payload: {
      projectRefId: string;
      description: string;
      attachment: string[];
      reasons: string;
      estimatePhaseIds: number[];
      subcontractors: number[];
    }
  ) {
    try {
      const response: any = await projectService.disputeProject(payload);
      commit("setProjectDispute", { ...response });
      return;
    } catch (error) {
      console.log();
      throw error;
    }
  },

  async onAcceptAndRejectChangeEstimateRequest(
    { commit }: { commit: Commit },
    payload: {
      changeRequestId: number;
      status: string;
    }
  ) {
    try {
      const response: any =
        await projectService.onAcceptAndRejectChangeEstimateRequest(
          payload.changeRequestId,
          payload.status
        );
      return response;
    } catch (error) {
      console.log();
      throw error;
    }
  },

  async getDisputeProject(
    { commit }: { commit: Commit },
    payload: {
      projectRefId: string;
    }
  ) {
    try {
      const response: any = await projectService.getDisputeProject(
        payload.projectRefId
      );
      commit("setProjectDispute", response);
    } catch (error) {
      console.log();
    }
  },
  async closeDisputeProject(
    { commit }: { commit: Commit },
    payload: {
      disputeIssueId: string;
    }
  ) {
    const response: any = await projectService.closeDisputeProject(
      payload.disputeIssueId
    );
    return response;
  },
  async updateCloseDisputeRequest(
    { commit }: { commit: Commit },
    request: {
      disputeRequestId: number;
      payload: any;
    }
  ) {
    const response: any = await projectService.updateCloseDisputeRequestStatus(
      request.disputeRequestId,
      request.payload
    );

    return response;
  },

  async requestForExtension(
    { commit }: { commit: Commit },
    request: {
      disputeIssueId: string;
      payload: any;
    }
  ) {
    const response: any = await projectService.requestForExtension(
      request.disputeIssueId,
      request.payload
    );
    return response;
  },

  async makeDisputeProjectOffer(
    { commit }: { commit: Commit },
    payload: {
      description: string;
      attachment: string[];
      disputeIssueId: number;
    }
  ) {
    const response: any = await projectService.makeDisputeProject(payload);
    return response;
  },

  async acceptDisputeProjectOffer(
    { commit }: { commit: Commit },
    payload: {
      disputeOfferId: number;
      status: DisputeRequestStatusEnums;
    }
  ) {
    const response: any = await projectService.acceptDisputeProject(
      payload.disputeOfferId,
      { status: payload.status }
    );
    return response;
  },
  async rejectDisputeProjectOffer(
    { commit }: { commit: Commit },
    payload: {
      disputeOfferId: number;
      status: DisputeRequestStatusEnums;
      reject_reason: string;
    }
  ) {
    const response: any = await projectService.rejectDisputeProject(
      payload.disputeOfferId,
      { status: payload.status, reject_reason: payload.reject_reason }
    );
    return response;
  },
};
